module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0028.jpg?v=19b69dea";